import { CalendarEventStatus, CalendarEventStatusName } from 'src/app/models/calendar-event.interface';

export type CalendarEventStatusInteractionState = 'editable' | 'locked' | 'updating' | 'unavailable';

interface CalendarEventStatusInteractionOptions {
  statusName?: CalendarEventStatusName;
  hasCurrentStatus: boolean;
  hasValidEventId: boolean;
  hasCompleteCatalog: boolean;
  isUpdating: boolean;
}

export function isTerminalCalendarEventStatus(statusName?: CalendarEventStatusName): boolean {
  return statusName === 'COMPLETED' || statusName === 'CANCELED';
}

export function isManuallySelectableCalendarEventStatus(statusName: CalendarEventStatusName): boolean {
  return statusName !== 'OVERDUE';
}

export function getCalendarEventManualStatusOptions(
  statuses: CalendarEventStatus[],
  currentStatus?: CalendarEventStatus
): CalendarEventStatus[] {
  const options = statuses.filter(status =>
    isManuallySelectableCalendarEventStatus(status.name) || status.id === currentStatus?.id
  );

  if (currentStatus && !options.some(status => status.id === currentStatus.id)) {
    options.unshift(currentStatus);
  }

  return options;
}

export function getCalendarEventStatusInteractionState(
  options: CalendarEventStatusInteractionOptions
): CalendarEventStatusInteractionState {
  if (isTerminalCalendarEventStatus(options.statusName)) return 'locked';
  if (options.isUpdating) return 'updating';
  if (!options.hasCurrentStatus || !options.hasValidEventId || !options.hasCompleteCatalog) {
    return 'unavailable';
  }
  return 'editable';
}
